import { ErrorLink } from '@apollo/client/link/error';
import { captureException } from '@sentry/react';

import { useAuthStore } from '@/core/store/auth/authStore';

export type VeevaLinkContext = {
	userStatus: string;
} | null;

export const errorLink = new ErrorLink(
	({ networkError, graphQLErrors, operation, forward }) => {
		const username = useAuthStore.getState().authUsername;
		const domain = username?.split('@')[1];

		if (graphQLErrors) {
			graphQLErrors.forEach(err => {
				console.error(
					`[GraphQL error in ${operation.operationName}]: ${err?.message}`
				);
				captureException(
					`[GraphQL error in ${operation.operationName}]: ${err?.message}`,
					{
						user: {
							domain
						},
						extra: {
							operationName: operation.operationName,
							query: operation.query,
							variables: operation.variables
						}
					}
				);
			});
		}

		if (
			networkError?.name === 'ServerError' &&
			'statusCode' in networkError &&
			networkError.statusCode == 401
		) {
			operation.setContext({
				ODCO: {
					userStatus: 'INVALID_TOKEN'
				} as VeevaLinkContext
			});
		}

		return forward(operation);
	}
);
